import React from 'react';
import { Link } from 'react-router-dom';
import { isRelativeUrl } from '@jetshop/core/helpers/isRelativeUrl';

export const LinkEvaluator = ({ link, children }) => {
  if (link?.value) {
    return typeof linkValue === 'string' && !isRelativeUrl(link?.value) ? (
      <a href={link?.value} className={'external-link link-evaluator'}>
        {children}
      </a>
    ) : (
      <Link to={link?.value} className={'internal-link link-evaluator'}>
        {children}
      </Link>
    );
  }

  return (
    <div style={{ height: '100%' }} className={'no-link link-evaluator'}>
      {children}
    </div>
  );
};
